<div class="flex gap-2">
  <p-radioButton
    [id]="id"
    [tabindex]="getTabIndex()"
    [formControl]="getFormControl()"
    [value]="getValue()"
    [disabled]="getDisabled()"
  />
  <eo-form-label
    *ngIf="isVisible()"
    [formId]="id"
    [label]="getLabel()"
    [required]="isRequired()"
  />
</div>
